// Contact form success scroll
(function() {
  const contactFormSuccess = document.querySelector('.form__message .form__success-field');
  if (contactFormSuccess) {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.addEventListener('load', function() {
      setTimeout(function() {
        contactFormSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    });
  }
})();

// Open minicart when a product is added to cart from Swym Wishlist
(function() {
  var lastKnownCartItemCount = null;
  var refreshTimer = null;

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    }).then(function(response) {
      return response.json();
    });
  }

  function fetchCartSections(cartDrawer) {
    var sectionsToRender = cartDrawer.getSectionsToRender();

    return fetch(
      window.Shopify.routes.root +
        '?sections=' +
        sectionsToRender.map(function(s) { return s.id; }).join(',') +
        '&_=' +
        Date.now()
    ).then(function(response) {
      return response.json();
    });
  }

  function waitForCartChange(previousItemCount, attempts) {
    attempts = attempts || 0;

    return fetchCart().then(function(cart) {
      if (
        previousItemCount === null ||
        cart.item_count > previousItemCount ||
        attempts >= 6
      ) {
        lastKnownCartItemCount = cart.item_count;
        return cart;
      }

      return new Promise(function(resolve) {
        setTimeout(resolve, 250);
      }).then(function() {
        return waitForCartChange(previousItemCount, attempts + 1);
      });
    });
  }

  function refreshAndOpenCartDrawer(previousItemCount) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || cartDrawer.dataset.cartType === 'page') return;

    waitForCartChange(previousItemCount)
      .then(function() {
        return fetchCartSections(cartDrawer);
      })
      .then(function(response) {
        cartDrawer.renderContents({ sections: response }, !cartDrawer.isOpen);
      })
      .catch(function(e) {
        console.error('Failed to refresh cart drawer after Swym add to cart', e);
      });
  }

  function scheduleCartDrawerRefresh(previousItemCount, delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function() {
      refreshAndOpenCartDrawer(previousItemCount);
    }, delay || 0);
  }

  function addSwymAddedToCartListener(swat, listener) {
    var eventNames = ['sw:addedtocart'];

    if (swat.JSEvents && swat.JSEvents.addedToCart) {
      eventNames.push(swat.JSEvents.addedToCart);
    }

    eventNames
      .filter(function(eventName, index) {
        return eventNames.indexOf(eventName) === index;
      })
      .forEach(function(eventName) {
        swat.evtLayer.addEventListener(eventName, listener);
      });
  }

  function onSwymReady(swat) {
    // Open mini-cart when Swym adds item to cart via Swym event
    addSwymAddedToCartListener(swat, function() {
      scheduleCartDrawerRefresh(lastKnownCartItemCount);
    });

    // Also listen for clicks on Swym add-to-cart buttons as fallback
    document.addEventListener('click', function(e) {
      const addToCartBtn = e.target.closest('.swym-storefront-layout-grid-item-add-to-cart-button, [data-action="add-to-cart"]');
      if (addToCartBtn) {
        var previousItemCount = lastKnownCartItemCount;
        scheduleCartDrawerRefresh(previousItemCount, 750);
      }
    });
  }

  fetchCart()
    .then(function(cart) {
      lastKnownCartItemCount = cart.item_count;
    })
    .catch(function() {
      lastKnownCartItemCount = null;
    });

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymReady);
})();
